import { Box, Typography } from "@mui/material";
import { useClientDetails } from "../../context/clientDetailsContext";

function ImageWrapper() {
  const {
    client: { details },
  } = useClientDetails();

  if (!details) {
    throw Error("Client details are required");
  }

  return (
    <>
      <Typography sx={{ paddingBottom: 4 }} variant="h6">
        Image
      </Typography>
      {details.imageUrl ? (
        <Box
          component="img"
          sx={{
            objectFit: "scale-down",
            maxHeight: 152,
            maxWidth: 152,
          }}
          alt="client image"
          src={details.imageUrl}
        />
      ) : (
        <Typography variant="body1">No profile picture</Typography>
      )}
    </>
  );
}

export default ImageWrapper;
